import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tab, Nav } from "react-bootstrap";

class whatsappFloatIcon extends Component {
  render() {
    return (

      <a href="https://wa.me/447418315039" target="_blank" rel="noopener noreferrer" className='float-icon-wsp'>
        <img src={process.env.PUBLIC_URL + "assets/images/whatsapp.svg"} className="img-fluid image-fit-w" alt="logo" />
      </a>


    );
  }
}

export default whatsappFloatIcon;